<div class="card">

    <div class="card-body">
        <h5 class="card-title">Contact</h5>
        <div class="custom-form" [formGroup]="contactForm">
            <div style="width: 70%">
                <label class="form-label">Name</label>
                <dx-text-box [formControlName]="'name'" [as-validator]="customErrors" placeholder="Name...">
                </dx-text-box>
                <label class="form-label">Email</label>
                <dx-text-box [formControlName]="'email'" [as-validator]="customErrors"
                    placeholder="Enter a valid email address...">
                </dx-text-box>
                <label class="form-label">Phone number</label>
                <dx-text-box [formControlName]="'phoneNumber'" [as-validator]="customErrors"
                    placeholder="Phone number...">
                </dx-text-box>
                <label class="form-label">Subject</label>
                <dx-text-box [formControlName]="'subject'" [as-validator]="customErrors"
                    placeholder="Please enter a subject...">
                </dx-text-box>
                <label class="form-label">Question</label>
                <dx-text-area [formControlName]="'question'" [as-validator]="customErrors"
                    placeholder="Enter your question/comment here..." [height]="90">
                </dx-text-area>
            </div>
            <br>
            <ng-container *ngIf="sendingMail.asObservable() | async as isSendingMail">
                <ng-container *ngIf="isSendingMail.value == true">
                <button style="text-align: start; width: 110px;" type="button" class="btn btn-success loading">
                    Sending
                </button>
            </ng-container>
            <ng-container *ngIf="isSendingMail.value == false">
                <button style="width: 110px;" type="button" class="btn btn-success"
                    (click)="sendMail()">
                    Send
                </button>
            </ng-container>
            </ng-container>
            <br>
            <label class="form-label">Optional attachments</label>
            <div>
            </div>
            <dx-file-uploader #fileUploader [multiple]="true" accept="*" [(value)]="value" uploadMode="useForm"
                (onValueChanged)="onFileDropped($event)" [maxFileSize]="10240"></dx-file-uploader>
            <span class="note">Maximum file size: <span>10 MB</span>.</span>
            <ng-container *ngIf="items$ | async as item">

                <div class="container">
                    <ng-container *ngFor="let i of item">
                        <app-shell-file-upload-tile (removeItem)="removeData($event)" style="padding-right: 20px"
                            [item]="i"></app-shell-file-upload-tile>
                    </ng-container>
                </div>
            </ng-container>

        </div>
    </div>
</div>